var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAnalysisBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6214 0L43.2429 12.5V37.5L21.6214 50L0 37.5V12.5L21.6214 0Z",
    fill: "#1C2743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19C21.6685 19 21.3505 19.1317 21.1161 19.3661C20.8817 19.6005 20.75 19.9185 20.75 20.25V34C20.75 34.3315 20.8817 34.6495 21.1161 34.8839C21.3505 35.1183 21.6685 35.25 22 35.25C22.3315 35.25 22.6495 35.1183 22.8839 34.8839C23.1183 34.6495 23.25 34.3315 23.25 34V20.25C23.25 19.9185 23.1183 19.6005 22.8839 19.3661C22.6495 19.1317 22.3315 19 22 19ZM30.75 14C30.4185 14 30.1005 14.1317 29.8661 14.3661C29.6317 14.6005 29.5 14.9185 29.5 15.25V34C29.5 34.3315 29.6317 34.6495 29.8661 34.8839C30.1005 35.1183 30.4185 35.25 30.75 35.25C31.0815 35.25 31.3995 35.1183 31.6339 34.8839C31.8683 34.6495 32 34.3315 32 34V15.25C32 14.9185 31.8683 14.6005 31.6339 14.3661C31.3995 14.1317 31.0815 14 30.75 14ZM13.25 24C12.9185 24 12.6005 24.1317 12.3661 24.3661C12.1317 24.6005 12 24.9185 12 25.25V34C12 34.3315 12.1317 34.6495 12.3661 34.8839C12.6005 35.1183 12.9185 35.25 13.25 35.25C13.5815 35.25 13.8995 35.1183 14.1339 34.8839C14.3683 34.6495 14.5 34.3315 14.5 34V25.25C14.5 24.9185 14.3683 24.6005 14.1339 24.3661C13.8995 24.1317 13.5815 24 13.25 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAnalysisBox);
export default __webpack_public_path__ + "static/media/ico-analysis-box.bc417c00920460006f20c90ed082b754.svg";
export { ForwardRef as ReactComponent };